import React, { MouseEvent, ReactNode } from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Label from '@/components/form/Label/Label';
import { useFormContext } from 'react-hook-form';
import TextField from '@/components/form/TextField/TextField';
import { FlexElement } from '@/features/forms/CrieSeuRoteiro/CrieSeuRoteiro.styles';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';

export interface FormAccomodationProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const FormAccomodation = ({ children, ...props }: FormAccomodationProps) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<FormCreateJourneyDataType>();

  return (
    <Fieldset size="lg" align="center">
      <legend>Gostaria de incluir acomodação?</legend>
      <FlexElement>
        <FieldGroup>
          <Label htmlFor="travelAccommodationCategory">Categoria de hotéis</Label>
          <TextField
            id="travelAccommodationCategory"
            error={errors.travelAccommodationCategory?.message}
            helperText="Ex. turística, primeira, luxo"
            {...register('travelAccommodationCategory')}
          />
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelAccommodationType">Tipo de acomodação</Label>
          <TextField
            id="travelAccommodationType"
            error={errors.travelAccommodationType?.message}
            helperText="Ex. duplo, triplo, individual e familiar."
            {...register('travelAccommodationType')}
          />
        </FieldGroup>
      </FlexElement>
    </Fieldset>
  );
};

export default FormAccomodation;
